import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setCookie, clearCookie, getUserDetails } from '../../functions/Auth';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Header from '../Headers/Header';
import Cookies from 'js-cookie';

import API_PATH from "../../constants/config.json";

const queryString = require('query-string');

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;


//Start signin form css ...
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '98%',
      zIndex:35
    },
  },
  rootBox: {
    flexGrow: 1,
  },
  paper: {
    width: '100%',
    boxShadow: 'none',
    display: 'flex'
  },
  signMain: {
    position: 'fixed',
    width: '100%',
    background: 'rgba(0,0,0,.5)',
    height: '100vh',
    top: '0',
    zIndex: '35'
  },
  signInBtn: {
    border: '1px solid rgba(36, 97, 142, 1)',
    color: '#fff',
    background: 'rgba(36, 97, 142, 1)!important',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '14px',
      width: '140px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '24pt',
      width: '180px',
      marginBottom: '10px',
    },
    fontFamily: 'Avenir Light',
    '& .MuiCircularProgress-root': {
      color: '#fff',
      '@media only screen and (max-width: 3500px)': {
        width: '25px !important',
        height: '25px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '45px !important',
        height: '45px !important',
      },
    }
  },
  formLogo: {
    textAlign: 'center',
    width: '100%',
    paddingTop: '15px',
    '& p': {
      textAlign: 'right',
      margin: '0px 0 -20px',
      paddingRight: '15px',
      fontSize: '25px',
    },
    '& a': {
      color: '#24618E',
    }
  },
  rootForm: {
    margin: '10px auto 0',
    border: '1px solid rgba(0, 167, 93, 1)',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '1px 4px 5px 1px #ccc',
    '@media only screen and (max-width: 3500px)': {
      width: '80%',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '85%',
    },
    '& input#email': {
      padding: '10px',
    },
    '& input#password': {
      padding: '10px',
    },
    '& h3': {
      color: '#24618E',
      marginTop: '0px',
      marginBottom: '0',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '26pt',
      },
    }
  },
  formInput: {
    width: '100%',
  },
  errorInput: {
    width: '100%',
    backgroundColor: '#F2DEDE',
    border: '1px solid #CC0000'
  },
  OtherLink: {
    width: '80%',
    margin: '0 auto',
    '& a': {
      color: '#24618E',
    }
  },
  errIcon: {
    fontSize: '26px',
    color: '#CC0000',
    margin: '2%'
  },
  errMsgSignIn: {
    '& span': {
      fontSize: '11pt !important'
    }
  },
  userFormContainer: {
    '@media only screen and (max-width: 3500px)': {
      width: '500px',
      paddingTop: '90px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '650px',
      maxWidth: '650px',
      paddingTop: '250px',
      '& input': {
        fontSize: '22pt',
      }
    },
  },
  rememberMeCheckBox: {
    '@media only screen and (min-width: 3501px)': {
      '& span': {
        fontSize: '18pt',
      }
    },
  },
  closeIcon: {
    '&:hover': {
      color: '#CC0000',
    }
  },
  formIcon:{
    '@media only screen and (max-width: 3500px)': {
      width: '215px', 
      height:'50px'
    },
    '@media only screen and (min-width: 3501px)': {
      width: '300px', 
      height:'70px'
    },
  }
}));
//End signin form css ...

//Start SignIn component code ...
const SignIn = (props) => {
  let history = useHistory();
  const [spacing, setSpacing] = React.useState(2);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [values, setValues] = React.useState({
    email: "",
    pwd: ""
  });
  const [errMsg, setErrMsg] = React.useState(null);
  const [errEmail, setErrEmail] = React.useState(null);
  const [errPassword, setErrPassword] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [loader, setLoader] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [getRememberMe, setRememberMe] = React.useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (props.location) {
      const parsed = queryString.parse(props.location.search);
      if (parsed && parsed.emailverification == 'true') {
        setEmail(parsed.email);
        setValues({ ...values, email: parsed.email });
        setErrMsg('Your email has been validated and you\'re ready to explore');
        setErrPopUp(true);
        setErrMsgType('success');
      } else if (parsed && parsed.emailverification == 'false') {
        setErrMsg('Link has been expired.');
        setErrPopUp(true);
        setErrMsgType('error');
      } else if (parsed && parsed.isadmin == 'true') {
        setEmail(parsed.email);
        setValues({ ...values, email: parsed.email });
      } else if (props.location.state) {
        if (props.location.state.invited) {
          setErrMsg('A verification link has been sent to the email that was provided.');
          setErrPopUp(true);
          setErrMsgType('success');
        }
      }
    }
  }, [])

  const handleChange = name => event => {
    if (name == 'email') {
      setEmail(event.target.value);
    }
    setErrEmail(false);
    setErrPassword(false);
    setValues({ ...values, [name]: event.target.value });
  }
  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };


  //This method is use for Sign In form validations start ..
  const validateForm = async e => { 
    setErrMsg(null)
    e.preventDefault()
    let checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;    
    if (values.email == '' &&
      values.pwd == '') {
      setErrEmail(true);
      setErrPassword(true);
      setErrMsg('All fields are required');
      setErrPopUp(true)
    } else if (values.email == '') {
      setErrEmail(true)
      setErrMsg('Email required');
      setErrPopUp(true)
    } else if (!checkEmail.test(values.email)) {
      setErrEmail(true)
      setErrMsg('Email format must be like yourname@example.com');
      setErrPopUp(true)
    } else if (values.pwd == '') {
      setErrPassword(true);
      setErrMsg('Password required.');
      setErrPopUp(true)
    } else {
      signInUser();
    }
  }
  //This method is use for Sign In form validations end ..


 //This method is use for API call to sign in user start ..
  const signInUser = () => { 
    setLoader(true);
    clearCookie('alLogIn');
    try {
      axios({
        method: 'post',
        data: { ...values, ...{ rememberMe: getRememberMe } },
        url: API_URL + API_PATH.signInAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            if (response.data.session) {
              await setCookie('session', response.data.session);
              await setCookie('email', values.email);
              history.push({
                pathname: '/set_new_password',
                state: { newLogin: true }
              });
            }
            else {
              await setCookie('email', response.data.email);
              await setCookie('idToken', response.data.IdToken);
              await setCookie('payload', response.data.payload);
              await setCookie('atexpiry', response.data.access_token_expiry);
              await setCookie('alLogIn', getRememberMe);
              await refreshToken();
            }
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
        .catch(function (error) {
          if (error.response) {
            setErrMsgType('error')
            setErrMsg(error.response.data.message.message);
            setErrPopUp(true)
            setLoader(false);
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }
  //This method is use for API call to sign in user end ..


  //This method is use for call refresh token start ..
  const refreshToken = () => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getcsrftoken,
      })
        .then(async function (response) {
          if (response && response.data && response.data.csrfToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken;
            await getProfile(response.data.csrfToken);
          } else {
            if (Cookies.get('email')) {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
            }
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
          setLoader(false);
        })
        .catch(function (error) {
          if (Cookies.get('email')) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
          }
          setErrMsgType('error')
          setErrMsg('Something went wrong.');
          setErrPopUp(true)
          setLoader(false);
        })
    } catch (error) {
      if (Cookies.get('email')) {
        clearCookie('email');
        clearCookie('payload');
        clearCookie('idToken');
        clearCookie('atexpiry');
        clearCookie('alLogIn');
      }
      setErrMsgType('error')
      setErrMsg('Something went wrong.');
      setErrPopUp(true)
      setLoader(false);
    }
  }
  //This method is use for call refresh token end ..


  //This method is use for get user information start ...
  const getProfile = async (csrfToken) => {
    let details = await getUserDetails();
    try {
      axios({
        method: 'get',
        headers: {
          'X-CSRF-Token': csrfToken
        },
        url: API_URL + API_PATH.getMyProfileAPI + `${details.user_id}`,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            await setCookie('firstName', response.data.data.first_name);
            await setCookie('organization', response.data.data.organization);
            await setCookie('lastName', response.data.data.last_name);
            history.push({
              pathname: '/UsersDashboard',
              state: { newLogin: true }
            });

          } else {
            if (Cookies.get('email')) {
              clearCookie('email');
              clearCookie('payload');
              clearCookie('idToken');
              clearCookie('organization');
              clearCookie('atexpiry');
              clearCookie('alLogIn');
            }
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
          setLoader(false);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.message) {
              setErrMsgType('error')
              setErrMsg(error.response.data.message.message);
              setErrPopUp(true)
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true)
            }
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
          }
          if (Cookies.get('email')) {
            clearCookie('email');
            clearCookie('payload');
            clearCookie('idToken');
            clearCookie('organization');
            clearCookie('atexpiry');
            clearCookie('alLogIn');
          }
          setLoader(false);
        })
    } catch (error) {
      console.error(error);
    }
  }
 //This method is use for get user information end ...


  const handleRemember = () => {
    setRememberMe(prev => !prev);
  }

  return (
    <React.Fragment>
      <Header />
      <CssBaseline />
      <div className={classes.signMain}>
        <Container className={classes.userFormContainer} maxWidth="sm">
          <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '360px', paddingBottom: '10px', position: 'relative', border: '1px solid #24618E', borderRadius: '5px', }}>
            <div className={classes.formLogo}>
              <p><NavLink className={classes.closeIcon} to="/" title='Close'><FontAwesomeIcon icon={faTimes} title='Close' /></NavLink></p>
              <img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.formIcon}></img>
            </div>
            {errMsg ? <div className={classes.errMsgSignIn}><ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /></div> : null}
            <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)} >
              <h3>Sign In</h3>
              <img src={require('../../assets/images/hrimg.svg')} style={{ marginBottom: '10px', width: '100%', height: '1px' }} />
              <Grid container className={classes.rootBox} spacing={spacing}>
                <Grid item xs={12}>
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="email" className={errEmail ? classes.errorInput : classes.formInput} placeholder="Email *" type="email" variant="outlined" required onChange={handleChange('email')} data-testid='email' value={email} />
                        {errEmail ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}

                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <TextField id="password" className={errPassword ? classes.errorInput : classes.formInput} placeholder="Password *" type="password" variant="outlined" required onChange={handleChange('pwd')} data-testid='password' />
                        {errPassword ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} >
                        <FormControlLabel
                          value="Remember me on this computer"
                          control={<Checkbox color="primary" value={getRememberMe} onChange={handleRemember} />}
                          label="Remember me on this computer"
                          labelPlacement="end"
                          id="reminder_check_bx"
                          className={classes.rememberMeCheckBox}
                        />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className={classes.paper} style={{ textAlign: 'center', display: 'block' }} >
                        <Button type="submit" variant="outlined" id="signIn_btn" className={classes.signInBtn} data-testid='signIn_btn'>
                          {loader == true ?
                            <CircularProgress />
                            :
                            'Sign In'
                          }
                        </Button>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
            <div className={classes.OtherLink}>
              <p style={{ marginBottom: '5px' }}><NavLink to="/forgot_password" data-testid='forgotPwdLink'>Forgot your password?</NavLink></p>
              <p style={{ marginTop: '5px' }}><NavLink to="/sign_up" data-testid='signUpLink'>Sign up for an account</NavLink></p>
            </div>
          </Typography>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default SignIn
//End SignIn component code ...